const pocitaniDoSta = () => {
	return [
		{
			id: 1,
			priklad: '80 + 20',
			moznosti: [
				{
					id: 1,
					moznost: '100',
				},
				{
					id: 2,
					moznost: '90',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '85',
				},
			],
			vysledek: '100',
		},
		{
			id: 2,
			priklad: '55 + 30',
			moznosti: [
				{
					id: 1,
					moznost: '85',
				},
				{
					id: 2,
					moznost: '75',
				},
				{
					id: 3,
					moznost: '95',
				},
				{
					id: 4,
					moznost: '80',
				},
			],
			vysledek: '85',
		},
		{
			id: 3,
			priklad: '90 - 30',
			moznosti: [
				{
					id: 1,
					moznost: '60',
				},
				{
					id: 2,
					moznost: '70',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '65',
				},
			],
			vysledek: '60',
		},
		{
			id: 4,
			priklad: '81 - 9',
			moznosti: [
				{
					id: 1,
					moznost: '74',
				},
				{
					id: 2,
					moznost: '73',
				},
				{
					id: 3,
					moznost: '71',
				},
				{
					id: 4,
					moznost: '72',
				},
			],
			vysledek: '72',
		},
		{
			id: 5,
			priklad: '13 + 15',
			moznosti: [
				{
					id: 1,
					moznost: '29',
				},
				{
					id: 2,
					moznost: '27',
				},
				{
					id: 3,
					moznost: '28',
				},
				{
					id: 4,
					moznost: '26',
				},
			],
			vysledek: '28',
		},
		{
			id: 6,
			priklad: '100 - 35',
			moznosti: [
				{
					id: 1,
					moznost: '75',
				},
				{
					id: 2,
					moznost: '65',
				},
				{
					id: 3,
					moznost: '60',
				},
				{
					id: 4,
					moznost: '55',
				},
			],
			vysledek: '65',
		},
		{
			id: 7,
			priklad: '27 - 11',
			moznosti: [
				{
					id: 1,
					moznost: '15',
				},
				{
					id: 2,
					moznost: '17',
				},
				{
					id: 3,
					moznost: '16',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '16',
		},
		{
			id: 8,
			priklad: '51 + 26',
			moznosti: [
				{
					id: 1,
					moznost: '75',
				},
				{
					id: 2,
					moznost: '77',
				},
				{
					id: 3,
					moznost: '76',
				},
				{
					id: 4,
					moznost: '78',
				},
			],
			vysledek: '77',
		},
		{
			id: 9,
			priklad: '19 + 19',
			moznosti: [
				{
					id: 1,
					moznost: '37',
				},
				{
					id: 2,
					moznost: '39',
				},
				{
					id: 3,
					moznost: '38',
				},
				{
					id: 4,
					moznost: '36',
				},
			],
			vysledek: '38',
		},
		{
			id: 10,
			priklad: '24 - 6',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '17',
				},
				{
					id: 3,
					moznost: '19',
				},
				{
					id: 4,
					moznost: '18',
				},
			],
			vysledek: '18',
		},
		{
			id: 11,
			priklad: '24 - 13',
			moznosti: [
				{
					id: 1,
					moznost: '10',
				},
				{
					id: 2,
					moznost: '12',
				},
				{
					id: 3,
					moznost: '13',
				},
				{
					id: 4,
					moznost: '11',
				},
			],
			vysledek: '11',
		},
		{
			id: 12,
			priklad: '30 - 15',
			moznosti: [
				{
					id: 1,
					moznost: '16',
				},
				{
					id: 2,
					moznost: '17',
				},
				{
					id: 3,
					moznost: '14',
				},
				{
					id: 4,
					moznost: '15',
				},
			],
			vysledek: '15',
		},
		{
			id: 13,
			priklad: '34 - 33',
			moznosti: [
				{
					id: 1,
					moznost: '1',
				},
				{
					id: 2,
					moznost: '2',
				},
				{
					id: 3,
					moznost: '0',
				},
				{
					id: 4,
					moznost: '3',
				},
			],
			vysledek: '1',
		},
		{
			id: 14,
			priklad: '35 + 35',
			moznosti: [
				{
					id: 1,
					moznost: '68',
				},
				{
					id: 2,
					moznost: '70',
				},
				{
					id: 3,
					moznost: '80',
				},
				{
					id: 4,
					moznost: '75',
				},
			],
			vysledek: '70',
		},
		{
			id: 15,
			priklad: '95 - 90',
			moznosti: [
				{
					id: 1,
					moznost: '7',
				},
				{
					id: 2,
					moznost: '6',
				},
				{
					id: 3,
					moznost: '5',
				},
				{
					id: 4,
					moznost: '4',
				},
			],
			vysledek: '5',
		},
		{
			id: 16,
			priklad: '32 + 39',
			moznosti: [
				{
					id: 1,
					moznost: '73',
				},
				{
					id: 2,
					moznost: '72',
				},
				{
					id: 3,
					moznost: '71',
				},
				{
					id: 4,
					moznost: '74',
				},
			],
			vysledek: '71',
		},
		{
			id: 17,
			priklad: '61 - 13',
			moznosti: [
				{
					id: 1,
					moznost: '49',
				},
				{
					id: 2,
					moznost: '47',
				},
				{
					id: 3,
					moznost: '48',
				},
				{
					id: 4,
					moznost: '46',
				},
			],
			vysledek: '48',
		},
		{
			id: 18,
			priklad: '90 - 45',
			moznosti: [
				{
					id: 1,
					moznost: '55',
				},
				{
					id: 2,
					moznost: '35',
				},
				{
					id: 3,
					moznost: '46',
				},
				{
					id: 4,
					moznost: '45',
				},
			],
			vysledek: '45',
		},
		{
			id: 19,
			priklad: '25 + 9',
			moznosti: [
				{
					id: 1,
					moznost: '35',
				},
				{
					id: 2,
					moznost: '32',
				},
				{
					id: 3,
					moznost: '33',
				},
				{
					id: 4,
					moznost: '34',
				},
			],
			vysledek: '34',
		},
		{
			id: 20,
			priklad: '13 + 33',
			moznosti: [
				{
					id: 1,
					moznost: '48',
				},
				{
					id: 2,
					moznost: '45',
				},
				{
					id: 3,
					moznost: '46',
				},
				{
					id: 4,
					moznost: '47',
				},
			],
			vysledek: '46',
		},
		{
			id: 21,
			priklad: '21 + 21',
			moznosti: [
				{
					id: 1,
					moznost: '43',
				},
				{
					id: 2,
					moznost: '42',
				},
				{
					id: 3,
					moznost: '40',
				},
				{
					id: 4,
					moznost: '41',
				},
			],
			vysledek: '42',
		},
		{
			id: 22,
			priklad: '30 + 58',
			moznosti: [
				{
					id: 1,
					moznost: '89',
				},
				{
					id: 2,
					moznost: '88',
				},
				{
					id: 3,
					moznost: '87',
				},
				{
					id: 4,
					moznost: '86',
				},
			],
			vysledek: '88',
		},
		{
			id: 23,
			priklad: '95 - 35',
			moznosti: [
				{
					id: 1,
					moznost: '50',
				},
				{
					id: 2,
					moznost: '60',
				},
				{
					id: 3,
					moznost: '65',
				},
				{
					id: 4,
					moznost: '55',
				},
			],
			vysledek: '60',
		},
		{
			id: 24,
			priklad: '100 - 15',
			moznosti: [
				{
					id: 1,
					moznost: '80',
				},
				{
					id: 2,
					moznost: '85',
				},
				{
					id: 3,
					moznost: '75',
				},
				{
					id: 4,
					moznost: '70',
				},
			],
			vysledek: '85',
		},
		{
			id: 25,
			priklad: '60 - 21',
			moznosti: [
				{
					id: 1,
					moznost: '38',
				},
				{
					id: 2,
					moznost: '48',
				},
				{
					id: 3,
					moznost: '49',
				},
				{
					id: 4,
					moznost: '39',
				},
			],
			vysledek: '39',
		},
	];
};

export default pocitaniDoSta;
